import { CSSProperties, useRef, useState } from "react";

import { BsChevronDown } from "react-icons/bs";
import useOutsideClick from "../../../hooks/useOutsideClick";

export type dropdownBasicProps = {
    id: number;
    label: string;
    children: Array<any>;
    styles?: CSSProperties;
    icon?: Element;
};
const DropdownBasic = (props: dropdownBasicProps) => {
    const buttonRef = useRef<HTMLDivElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const onOutsideClick = () => {
        setDropdownOpen(false);
    };
    useOutsideClick(buttonRef, onOutsideClick);

    return (
        <div
            className={"g-dropdown-basic" + (dropdownOpen ? "-selected" : "")}
            key={props.id}
            ref={buttonRef}
            title={props.label}
            style={props.styles}
        >
            <div
                className="findDropDownWrapper"
                tabIndex={0}
                onClick={() => setDropdownOpen(o => !o)}
            >
                <div className="Col1"> {props.label}</div>
                <div className="Col2">
                    <BsChevronDown style={{ fontSize: "10px", marginLeft: "10px", float: "right" }}> </BsChevronDown>
                </div>
            </div>
            <ul
                onMouseLeave={() => setDropdownOpen(false)}
                onClick={() => setDropdownOpen(false)}
                style={{ width: "100%" }}
            >
                {props.children}
            </ul>
        </div>
    );
};

export default DropdownBasic;
